export default __webpack_public_path__ + "static/media/5_1.3fd1360b.jpg";